
import {
  AppButton,
  QuoteInput,
  AppSection,
  Article
} from "@soenergy/frontend-library"
import NavLink from "@soenergy/frontend-library/src/components/NavLink"
import { getEnrolmentEntryUrl } from "@/helpers/enrolmentJourneyHelper"

export default {
  name: `GetQuoteHero`,
  components: { NavLink, QuoteInput, AppSection, Article },
  props: {
    heading: {
      type: String,
      default: null
    },
    text: {
      type: [Object, String],
      default: null
    },
    quoteInputLabel: {
      type: [Object, String],
      default: null
    },
    quoteButtonVariant: {
      type: String,
      default: null
    },
    buttonLabel: {
      type: String,
      default: null
    },
    button: {
      type: Array,
      default: null
    },
    fontColor: {
      type: String,
      default: null
    },
    backgroundColor: {
      type: String,
      default: null
    },
    telesalesId: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    referrer: {
      type: String,
      default: null
    },
    validPostcodeSubmittedEvent: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      AppButton
    }
  },
  computed: {
    buttonProps() {
      const buttonBlock = this.button && this.button[0]
      if (buttonBlock) {
        const { _uid, component, ...props } = buttonBlock
        return props
      }
      return null
    }
  },
  methods: {
    handleValidPostcode(data) {
      this.$store.dispatch("quote/setPostcodeAndReset", data.customerPostcode)
      this.$router.push(getEnrolmentEntryUrl())
      this.$analytics.sendEvent(this.validPostcodeSubmittedEvent)
    }
  }
}
